import BackendService from './BackendService'
import { http } from '../services/http'

export default class LoginService extends BackendService {
  login(user) {
    return http()
      .post('authenticate', user, { withCredentials: true })
      .then(this.validateCode)
      .then(response => {
        this.token = response.data.token
        return response.data.token
      })
      .catch(err => {
        console.log(err)
      })
  }

  logout() {
    this.token = ''
  }
}



// WEBPACK FOOTER //
// ./src/services/LoginService.js